import { Box, type BoxProps } from '@chakra-ui/react';
import React from 'react';

type NavTagTone = 'new' | 'live' | 'ai' | 'muted';

const TONES: Record<NavTagTone, { bg: string; color: string }> = {
  new: { bg: 'navDark.newTagBg', color: 'navDark.newTagText' },
  live: { bg: 'navDark.liveBg', color: 'navDark.liveText' },
  ai: { bg: 'navDark.aiBg', color: 'navDark.aiText' },
  muted: { bg: 'navDark.badgeBg', color: 'navDark.sectionLabel' },
};

/**
 * Word tag on a row of the dark menu ("New", "Live", "Creator app", "Coming
 * soon"), the one way to draw a word on the charcoal. A tinted
 * wash rather than a Badge: the Badge recipe is drawn for light surfaces and
 * reads as a lit sticker on the charcoal.
 */
const NavTag: React.FC<{
  tone?: NavTagTone;
  children: React.ReactNode;
  bg?: BoxProps['bg'];
  color?: BoxProps['color'];
}> = ({ tone = 'new', children, bg, color }) => (
  <Box
    as="span"
    display="inline-flex"
    alignItems="center"
    h="18px"
    px="6px"
    rounded="6px"
    bg={bg ?? TONES[tone].bg}
    color={color ?? TONES[tone].color}
    fontFamily="heading"
    fontSize="9.5px"
    fontWeight={700}
    letterSpacing="0.08em"
    textTransform="uppercase"
    lineHeight="1"
    whiteSpace="nowrap"
    flexShrink={0}
  >
    {children}
  </Box>
);

export default NavTag;
